import styled from 'styled-components'

interface ITextDadosContaProps {
  $fontWeight?: number | string
  $fontSize?: number
  $color?: string
  $lineHeigth?: string | number
}
export const ContainerCards = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin: 20px 30px;
`

export const TitleDadosConta = styled.span<ITextDadosContaProps>`
  font-family: Inter, Roboto, sans serif;
  font-weight: ${props => props.$fontWeight ?? 700};
  font-size: ${props => props.$fontSize ?? 32};
  color: ${props => props.$color ?? '#2D3A40'};
  line-height: ${props => props?.$lineHeigth ?? '130%'};
`
